export default __webpack_public_path__ + "static/media/icon_mail_close.46d07704.svg";